/* unplugin-vue-components disabled */import script from "./CashFloatClose.vue?vue&type=script&lang=ts&setup=true"
export * from "./CashFloatClose.vue?vue&type=script&lang=ts&setup=true"

import "./CashFloatClose.vue?vue&type=style&index=0&id=32739696&lang=scss"

const __exports__ = script;

export default __exports__